import { render, staticRenderFns } from "./ReplyCancellingGuardianOfChild.vue?vue&type=template&id=4ffa3ee4"
import script from "./ReplyCancellingGuardianOfChild.vue?vue&type=script&lang=ts"
export * from "./ReplyCancellingGuardianOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports